import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getToolsFromFirestore, deleteToolFromFirestore } from '../../firebase/toolService';
import { useAuth } from '../../firebase/AuthContext';
import { replaceToolInPosts } from '../../firebase/toolPostReplaceService';
import styles from './ToolReplace.module.css';

const ToolReplace = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toolId, usedPostsCount } = location.state || {};
  const [toolList, setToolList] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    async function fetchTools() {
      if (!user) return;
      const tools = await getToolsFromFirestore(user.uid);
      setToolList(tools.filter(t => t.id !== toolId));
    }
    fetchTools();
  }, [user, toolId]);

  const handleReplace = async () => {
    if (!selectedId) {
      alert('置き換える道具を選択してください');
      return;
    }
    // 投稿の道具IDを即座に入れ替え、元の道具も削除
    await replaceToolInPosts(toolId, selectedId);
    await deleteToolFromFirestore(toolId);
    alert('置き換え・削除が完了しました');
    navigate('/tools/list');
  };

  return (
    <div className={styles.container}>
      <h2>道具の置き換え</h2>
      <p>この道具は {usedPostsCount} 件の投稿で使われています。<br />どの道具に置き換えますか？</p>
      <select value={selectedId} onChange={e => setSelectedId(e.target.value)}>
        <option value="">選択してください</option>
        {toolList.map(tool => (
          <option key={tool.id} value={tool.id}>{tool.name}</option>
        ))}
      </select>
      <button className={styles.button} onClick={handleReplace} style={{marginLeft:12}}>置き換え</button>
      <button className={styles.button} onClick={() => navigate(-1)} style={{marginLeft:8}}>キャンセル</button>
    </div>
  );
};

export default ToolReplace;
